import { Injectable } from '@angular/core';
import { MessageService } from 'primeng/api';

@Injectable({
	providedIn: 'root', // Disponible en toda la app
})
export class MessageAlertService {
	constructor(private messageService: MessageService) {}

	/**
	 * Displays a toast message using PrimeNG MessageService.
	 * @param severity Type of message ('success', 'info', 'warn', 'error').
	 * @param summary Short title for the message.
	 * @param detail Detailed message.
	 */
	showMessage(severity: 'success' | 'info' | 'warn' | 'error', summary: string, detail: string): void {
		this.messageService.add({ severity, summary, detail });
	}
}
